export default {
  null: null,
  "00": "00 | Mercadoria para Revenda",
  "01": "01 | Matéria-Prima",
  "02": "02 | Embalagem",
  "03": "03 | Produto em Processo",
  "04": "04 | Produto Acabado",
  "05": "05 | Subproduto",
  "06": "06 | Produto Intermediário",
  "07": "07 | Material de Uso e Consumo",
  "08": "08 | Ativo Imobilizado",
  "09": "09 | Serviços",
  10: "10 | Outros insumos",
  99: "99 | Outras",
}